import { Type } from '@avro/types'
import { castArray, head } from 'lodash'
import type { NextApiRequest } from 'next'
import { decodeAvro, encodeAvro } from 'utils/avro'
import { ClientAuditLogEntry } from './types'

const AUDIT_LOG_HEADER_NAME = 'x-faros-audit-log'

const schema = Type.forSchema<ClientAuditLogEntry>({
  name: 'auditLogEntry',
  type: 'record',
  fields: [
    {
      name: 'resource',
      type: 'string',
    },
    {
      name: 'action',
      type: 'string',
    },
    {
      name: 'severity',
      type: 'string',
    },
    {
      name: 'description',
      type: 'string',
    },
    {
      name: 'graph',
      type: ['null', 'string'],
    },
  ],
})

export const createAuditLogHeader = (
  entry: ClientAuditLogEntry
): { [AUDIT_LOG_HEADER_NAME]: string } => {
  return {
    [AUDIT_LOG_HEADER_NAME]: encodeAvro(entry, schema),
  }
}

export const parseAuditLogHeader = (
  req: NextApiRequest
): ClientAuditLogEntry | null => {
  try {
    const value = head(castArray(req.headers[AUDIT_LOG_HEADER_NAME]))
    if (!value) {
      return null
    }

    return decodeAvro(value, schema)
  } catch {
    return null
  }
}
